import { render, staticRenderFns } from "./StoriesArticleIllustratedMainCopyVert.vue?vue&type=template&id=3ed2f9f1&scoped=true&"
import script from "./StoriesArticleIllustratedMainCopyVert.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleIllustratedMainCopyVert.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleIllustratedMainCopyVert.vue?vue&type=style&index=0&id=3ed2f9f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed2f9f1",
  null
  
)

export default component.exports